import { Component, EventEmitter, input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';

import { FlowchartStartNodeDto } from '@treetop/shared/model';

import { ActionTabComponent } from './components/action-tab/action-tab.component';
import { FindingTabComponent } from './components/finding-tab/finding-tab.component';
import { TechnicalInfoComponent } from '../../sub-components/technical-info/technical-info.component';

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    TranslocoModule,
    MatTabsModule,
    ActionTabComponent,
    FindingTabComponent,
    TechnicalInfoComponent,
  ],
  selector: 'flowchart-sidebar-start',
  templateUrl: './flowchart-sidebar-start.component.html',
  styleUrls: ['./flowchart-sidebar-start.component.scss'],
})
export class FlowchartSidebarStartComponent {
  public sidebarElement = input<FlowchartStartNodeDto>();

  @Output() public flowchartElementDataChanged = new EventEmitter<Partial<FlowchartStartNodeDto>>();

  protected component = new FormControl();
}
